import { selectClasses } from "src/components/Select/Select.constants.ts";
import * as styles from "src/components/Select/Select.style.ts";
import React from "react";

export const Arrow = ({
  disabled = false,
  isOpen,
  truncateOptions,
  isButton,
}: {
  disabled?: boolean;
  isOpen: boolean;
  truncateOptions?: boolean;
  isButton: boolean;
}) => {
  return (
    <div
      className={selectClasses.arrowWrapper}
      css={styles.arrowWrapper({
        isDisabled: disabled,
        truncateOptions: truncateOptions,
        isButton: isButton,
      })}
    >
      <i
        css={styles.arrow({ isOpen: isOpen })}
        className={`icon-15-arw_up ${selectClasses.arrow}`}
      />
    </div>
  );
};
